import React, { Component } from 'react'
import EventTeams from '../widgets/EventTeams';

const eventDetailsTemplateRow = (b, i) => (
    <li key={i.toString()} className='event-bet'>
        <div className='mvu-status orange'>
            <div className='mvu-status-indicator'></div>
            {/* <small>24 minutes ago</small> */}
        </div>
        {b.pick === "Draw" ?
            <small>{b.userName} bet on a draw</small>
            : <small>{b.userName} picked team {b.pick}</small>}
    </li>
)

export default class EventDetailsTemplate extends Component {

  

    getGameState(state) {

        switch (state) {

            case 'STARTED':
                return (<div className='mvu-status red'>
                    <div className='mvu-status-indicator'></div>
                    <small>Game is currently live</small>
                </div>)

            case 'PENDING':
                return (<div className='mvu-status green'>
                    <div className='mvu-status-indicator'></div>
                    <small>Game is open</small>
                </div>)

            case 'ENDED':
                return (<div className='mvu-status orange'>
                    <div className='mvu-status-indicator'></div>
                    <small>Game has ended</small>
                </div>)

        }

    }
   

    render() {
        return (<div id='event-detail-content-wrap'>
            <div id='event-detail-bottom-row' style={{ background: `linear-gradient(180deg, ${this.props.event ? this.props.event.team_one_colour : '#364247'}, ${this.props.event ? this.props.event.team_two_colour : '#364247'})` }}></div>
            <EventTeams showPoolDetails='true' event={this.props.event}></EventTeams>
            <div id='event-detail-content-bottom'>
                <div id='event-bets-list-wrap'>
                    {/* {(this.props.eventsBets == undefined) ? (
                        <div id='event-bets-empty'>
                            <small>No recent bets found</small>
                        </div>) : ( */}
                         {   (this.props.event && (this.props.eventsBets.length !== 0)) ? (<ul id='event-bets-list'>
                                {this.props.eventsBets.map((b, i) => (eventDetailsTemplateRow(b, i)))}
                            </ul>) : (
                                    <div id='event-bets-empty'>
                                        <small>No recent bets found</small>
                                    </div>)
                    }
                </div>
                <div id='event-detail-list-wrap'>
                    <div id='event-detail-list-header'>
                        <small>Game details</small>
                        {this.getGameState(this.props.event.state)}
                    </div>
                    <ul id='event-detail-list'>
                        <li className='event-detail'>
                            <small>Venue</small>
                            <small>{this.props.event.venue}</small>
                        </li>
                        <li className='event-detail'>
                            <small>Start time local</small>
                            <small>{this.props.event.startTimeLocal}</small>
                        </li>
                        {/* <li className='event-detail'>
                                    <small>Start time UTC</small>
                                    <small>{this.props.event.startTimeUTC}</small>
                                </li> */}
                    </ul>
                </div>
            </div>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/components/general/event/details/event-details-template.js